"use client";

import { useState } from "react";
import { Switch, Divider } from "antd";
import "antd/dist/reset.css";
import "./switch-custom.css"; // Import custom switch styles

export default function PrivacyPolicy() {
  const [sharingEnabled, setSharingEnabled] = useState(true);
  const [analyticsEnabled, setAnalyticsEnabled] = useState(true);

  return (
    <div className="w-full bg-white p-[16px]">
      <h1 className="text-[18px] font-poppins font-semibold text-[#171717]">
        Privacy Policy (Managed by Admin)
      </h1>

      <p className="text-[#171717] text-[14px] font-poppins mt-2 mb-6">
        Manage how your data is shared and take control of your digital
        footprint.
      </p>

      <Divider className="my-6 bg-gray-200" />

      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div className="pr-4">
            <p className="text-[14px] font-poppins text-[#171717]">
              Allow sharing session summaries with institution
            </p>
          </div>
          <Switch
            disabled
            checked={sharingEnabled}
            onChange={(checked) => setSharingEnabled(checked)}
            className="custom-switch"
          />
        </div>

        <div className="flex items-center justify-between">
          <div className="pr-4">
            <p className="text-[14px] font-poppins text-[#171717]">
              Allow analytics use of anonymized data
            </p>
          </div>
          <Switch
            disabled
            checked={analyticsEnabled}
            onChange={(checked) => setAnalyticsEnabled(checked)}
            className="custom-switch"
          />
        </div>
      </div>
    </div>
  );
}
